<template>
    <button type="button" 
        class="btn btn-default page-action" 
        data-toggle="modal" 
        :data-target="`#${target}`"
        :disabled="disabled">
        <i class="fa fa-file-excel-o" /> {{ label }}
    </button>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        label: {
            type: String,
            required: false,
            default: 'Import Excel',
        },
        target: {
            type: String,
            required: false,
            default: null,
        },
    }
}
</script>